import { useState } from 'react'
import { ResetPasswordForm } from './ResetPasswordForm'
import { makePostRequest, makeGetRequest } from 'utils/api'
import { URLS } from 'utils/constants'

const ResetPasswordContainer = () => {
  const [isSuccess, setIsSuccess] = useState(false)
  const [isError, setIsError] = useState(false)
  const formSubmit = async (values, { onError } = {}) => {
    try {
      const masterSchemaHeader = {
        'x-tenant-schema': 'master'
      }
      const tenant = await makeGetRequest('/v1/tenants/email', {
        params: {
          email: values.email
        },
        headers: masterSchemaHeader
      })

      if (tenant) {
        const tenantSchemaHeader = {
          'x-tenant-schema': tenant ? tenant.tenantId : 'public'
        }
        await makePostRequest(
          '/v1/users/forgot-password',
          {
            email: values.email,
            confirmPasswordUrl: `${window.location.origin}${URLS.CHANGE_PASSWORD}`,
            turnstileToken: values.turnstileToken || undefined
          },
          {
            headers: tenantSchemaHeader
          }
        )
        setIsSuccess(true)
      }
    } catch (e) {
      onError?.()
      setIsError(true)
    }
  }
  return <ResetPasswordForm isSuccess={isSuccess} isError={isError} formSubmit={formSubmit} />
}

export default ResetPasswordContainer
